module.exports = __webpack_public_path__ + "img/map_infield-mezzanine.07664f7f.jpg";